import script from "./PrioritySelector.vue?vue&type=script&setup=true&lang=js"
export * from "./PrioritySelector.vue?vue&type=script&setup=true&lang=js"

import "./PrioritySelector.vue?vue&type=style&index=0&id=022c8746&lang=css"

const __exports__ = script;

export default __exports__